import { useEffect, useState } from 'react';
import  AnchorLink from 'react-anchor-link-smooth-scroll'
import { Button } from '../Button/Button';
import { bg_video } from '../../assets'
import './Hero.css';

function Hero() {

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  window.scrollTo(0, 0)

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowSize]);

  return (
    <div className='hero-container'>
      {windowSize > 750 &&
        <video src={bg_video} autoPlay loop muted />
      }
      <h1>OWEN JONES</h1>
      <p>Developer | Full-Stack | AI & ML</p>
      <div className='hero-btns'>
        <AnchorLink href='#projects' offset={75}>
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
          >
            PROJECTS
          </Button>
        </AnchorLink>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          path="/connect"
        >
          CONNECT
        </Button>
      </div>
    </div>
  );
}

export default Hero;
